import(/* webpackMode: "eager" */ "/codebuild/output/src2540224303/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2540224303/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src2540224303/src/app/src/v2/containers/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2540224303/src/app/src/v2/views/events/components/EventsList/EventsList.tsx");
